import { inject, Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { StackedMessagesService } from '@shared/stacked-messages/stacked-messages.service';
import { VoivodeshipsFacade } from '@state/voivodeships';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class VoivodeshipsGuard {
  private readonly router = inject(Router);
  private readonly voivodeshipsFacade = inject(VoivodeshipsFacade);
  private readonly notifService = inject(StackedMessagesService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const exitUrlTree = this.router.createUrlTree(['/']);
    return this.voivodeshipsFacade.getVoivodeships$().pipe(
      take(1),
      map(voivos => {
        if (!voivos || !voivos.length) {
          this.notifService.showError({ message: 'NO_VOIVODESHIPS_CANT_ENTER' });
          return exitUrlTree;
        }
        return true;
      })
    );
  }
}
